import { render, staticRenderFns } from "./explosion.vue?vue&type=template&id=37d40eb7&"
import script from "./explosion.vue?vue&type=script&lang=ts&"
export * from "./explosion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports